const formValidation = require('../components/formValidation');
const createErrorNotification = require('../components/errorNotification');
const CoinCardAPI = require('./api');
const debounce = require('lodash/debounce');
const showMess = require('app_project/components/displayMessage');

const CoinCard = {

  /**
   * elements 
   */
  el: {
    toggle: $('#iHaveCoinCardChoice'),
    privacy_subscription: $('#privacy_subscription'),
    emailMessage: $('#form-email-error'),
    register_title: $('.register-title'),
    form: {
      submit: $('form.registration button[type="submit"]'),
      firstname: $('#registration-form-fname'),
      lastname: $('#registration-form-lname'),
      email: $('#registration-form-email'),
      birthday: $('#registration-form-birthday'),
      postalCode: $('#registration-form-postalCode'),
      prefixcode: $('#registration-prefixcode'),
      phone: $('#registration-phone'),
      gender: $('select[name$="dwfrm_profile_customer_gender"]'),
      address: $('#registration-address'),
      city: $('#registration-city'),
      state: $('#registration-state'),
      country: $('#registration-country'),
      wantCard: $('#registration-form-wantCard'),
      coincard: $('#registration-form-coincard')
    },
    divgroup: {
      registration: $('#form--new-registration'),
      subscription: $('#form--association-card'),
      extra_data: $('.i-want-coincard'),
      privacy0_group:{
        privacy0_div: $('div.form-group.custom-checkbox'),
        privacy0_input: $('div.form-group.custom-checkbox input#privacy0')
      } 
    },
    account_register_container: $('#account-register-container')
  },
  
  /**
   * api
   */
  api: CoinCardAPI,

  /**
   * configs 
   */
  config: {
    IS_INCLUDE: $('.register-page').attr('isincluded') === "true",
    rFLOW: $('.register-page').attr('rflow'),
    IS_REGISTRATION_ACCOUNT: $('.register-page').attr('is-registration-account') === "true",
    IS_SUBSCRIPTION_COINCASA: $('.register-page').attr('is-subscription-coincard') === "true",
  },

  /**
   * Toggle Coincard 
   */
  ToggleCoinCard: () => {
    // console.log('1');
    // if ($('form.registration').hasClass('subscription')) {
    //   console.log('2');
    //   $('.switch .slider').addClass('true');
    //   $('body').trigger('coincard:toggle:change');
    // }
    $('.switch .slider').on('click', function() {
      $(this).toggleClass('true');
      var hasCoinCard = $(this).hasClass('true');
      if ($('form.registration').hasClass('subscription')) {
        hasCoinCard = !hasCoinCard;
      }
      CoinCard.el.toggle.val(hasCoinCard);
      $('body').trigger('coincard:toggle:change');
    })
  },

  /**
   * Section Form
   */
  ChangeSection: () => {
    $('body').on('coincard:toggle:change', () => {
      if ($('form.registration').hasClass('subscription')) {    
        var newCoinCard = CoinCard.el.toggle.val() !== 'true';
        CoinCard.el.divgroup.registration.show();
        CoinCard.el.divgroup.subscription.hide();
        if (newCoinCard) {
          $('#form--new-registration > .row').show();
          $('.marketing-text').show();
          CoinCard.el.register_title.html(CoinCard.el.register_title.attr('data-label-new-coincard'));
          CoinCard.el.account_register_container.show();
          CoinCard.el.divgroup.privacy0_group.privacy0_div.show();
          CoinCard.el.divgroup.privacy0_group.privacy0_input.attr('required', 'required');
          CoinCard.el.form.firstname.attr('required', 'required');
          CoinCard.el.form.lastname.attr('required', 'required');
          CoinCard.el.form.email.attr('required', 'required');
          CoinCard.el.form.birthday.attr('required', 'required');
          CoinCard.el.form.postalCode.attr('required', 'required');
          CoinCard.el.form.prefixcode.attr('required', 'required');
          CoinCard.el.form.phone.attr('required', 'required');
          CoinCard.el.form.gender.attr('required', 'required');
          CoinCard.el.form.country.attr('required', 'required');
          CoinCard.el.form.wantCard.val(true);
          if (CoinCard.el.form.country.val() == 'IT') {
            CoinCard.el.form.state.attr('required', 'required');            
          }

          $('.btn-submit-coincard').html($('.btn-submit-coincard').attr('data-subscription-label'));
          $('.btn-submit-coincard').closest('.row').removeClass('justify-center mt-30').addClass('justify-end');
        } else {
          CoinCard.el.register_title.html(CoinCard.el.register_title.attr('data-label-associate-coincard'));
          CoinCard.el.divgroup.subscription.show();
          $('#form--new-registration > .row').hide();
          $('.marketing-text').hide();
          CoinCard.el.account_register_container.hide();
          CoinCard.el.divgroup.privacy0_group.privacy0_div.hide();
          CoinCard.el.divgroup.privacy0_group.privacy0_input.removeAttr('required');
          CoinCard.el.form.firstname.removeAttr('required');
          CoinCard.el.form.lastname.removeAttr('required');
          CoinCard.el.form.email.removeAttr('required');
          CoinCard.el.form.country.removeAttr('required');
          CoinCard.el.form.birthday.removeAttr('required');
          CoinCard.el.form.postalCode.removeAttr('required');
          CoinCard.el.form.prefixcode.removeAttr('required');
          CoinCard.el.form.phone.removeAttr('required');
          CoinCard.el.form.gender.removeAttr('required');
          CoinCard.el.form.state.removeAttr('required');
          CoinCard.el.form.wantCard.val(false);

          $('.btn-submit-coincard').html($('.btn-submit-coincard').attr('data-association-label'));
          $('.btn-submit-coincard').closest('.row').removeClass('justify-end').addClass('justify-center mt-30');
        }
      } else {
        CoinCard.ManageSection();
      }
      // CoinCard.ResetForm();
    })
  },

  ManageSection: () => {
    var hasCoinCard = CoinCard.el.toggle.val() === 'true';

    CoinCard.el.divgroup.registration.show();
    CoinCard.el.divgroup.subscription.hide();

    if (hasCoinCard) {
      CoinCard.el.divgroup.subscription.show();
    } 
  },

  ResetForm: () => {
    var isRegistrationForm = CoinCard.el.divgroup.registration.length;
    var isSubscriptionForm = CoinCard.el.divgroup.subscription.length;
    var isAuthenticated = CoinCard.el.form.firstname.attr('readonly');

    // If a Customer is Authenticated some mandatory fields are readonly;
    if (!isAuthenticated && (isRegistrationForm || isSubscriptionForm)) {
      CoinCard.el.form.firstname.val('');
      CoinCard.el.form.lastname.val('');
      CoinCard.el.form.email.val('');
      CoinCard.el.form.birthday.val('');
      CoinCard.el.form.postalCode.val('');
      CoinCard.el.form.phone.val('');
      CoinCard.el.form.gender.prop('selectedIndex', 0);
      CoinCard.el.form.address.val('');
      CoinCard.el.form.city.val('');
      CoinCard.el.form.state.val('');
      CoinCard.el.form.coincard.val('');
      CoinCard.el.emailMessage.html('');
    }

    // enable button submit
    CoinCard.el.form.submit.attr('disabled', false);
  },


  /**
   * Manage Requiring Data
   */
  ManageRequiringData: () => {

    /**
     * > Registration Page 
     */
    $('body').on('coincard:toggle:change', () => {
      var iWantCoincard = CoinCard.el.toggle.val() === 'true';
      /**
       * Validation Phone / Gender
       */
      $('.alert.alert-danger').remove();
      if (iWantCoincard) {
        CoinCard.el.form.coincard.attr('required', 'required').removeClass('error');
      } else {
        CoinCard.el.form.coincard.val('');
        CoinCard.el.form.coincard.removeAttr('required').removeClass('error');
      }
    })
  },

  CheckPreixCodeFiled: () => {
    CoinCard.el.form.prefixcode.val($('form.registration #prefixcode').val());
  },

  UpdatePreixCodeFiled: () => {
    $('form.registration #prefixcode').on('change', () => {
      CoinCard.el.form.prefixcode.val($('form.registration #prefixcode').val());
    })
  },

  CheckCountryField: () => {
    CoinCard.el.form.country.val($('form.registration #country').val());
    if ($('form.registration #country').val() !== 'IT'){
      $('form.registration .col--state').addClass('d-none');
      CoinCard.el.form.state.removeAttr('required');
      var regexStandard = CoinCard.el.form.postalCode.attr('data-regex');
      var postalCodeRegex = $('form.registration #registration-form-postalCode').attr("pattern");
      if (postalCodeRegex && postalCodeRegex!=regexStandard) {
        $('form.registration #registration-form-postalCode').attr("pattern", regexStandard);
      }
    }else{
      CoinCard.el.form.state.attr('required', 'required');
    }
  },

  UpdateCountryCode: () => {
    $('form.registration #country').on('change', () => {
      CoinCard.el.form.country.val($('form.registration #country').val());
      if ($('form.registration #country').val() !== 'IT') {
        $('form.registration .col--state').addClass('d-none');
        CoinCard.el.form.state.removeAttr('required');
        CoinCard.el.form.postalCode.val('');
        CoinCard.el.form.postalCode.removeAttr('required').removeClass('error');
        $('form.registration #state').val('');
        var regexStandard = CoinCard.el.form.postalCode.attr('data-regex');
        var postalCodeRegex = $('form.registration #registration-form-postalCode').attr("pattern");
        if (postalCodeRegex && postalCodeRegex!=regexStandard) {
          $('form.registration #registration-form-postalCode').attr("pattern", regexStandard);
        }
        CoinCard.el.form.state.val($('form.registration #state').val());
      } else {
        var country = $('form.registration #country').val()
        CoinCard.el.form.postalCode.attr('required', 'required').removeClass('error');
        $.ajax({
          url: $('form.registration #country').attr('data-url'),
          type: 'get',
          contentType: "application/json; charset=utf-8",
          data: country,
          success: function (data) {
            console.log('success');
            CoinCard.el.form.state.attr('required', 'required');
            $('form.registration #registration-form-postalCode').attr('required', 'required');
            var options = [];
                    options.push('<option label="', $('form.registration #state').attr('data-placeholder'), '" value=""/>');
                    $.each(data.jsonstates.data, function (index, value) {
                        options.push('<option id="', value.code, '" value="', value.code, '", regex-for-province="', value.regex, '">', value.description, '</option>');
                    });
            $('form.registration #state').html(options.join(''));
            $('form.registration .col--state').toggleClass('d-none');
          },
          error: function (err) {
            console.log('failed', err)
          },
        });
      }
    })
  },

  UpdateStateCode: () => {
    CoinCard.el.form.state.val($('form.registration #state').val());
    $('form.registration #state').on('change', () => {
      CoinCard.el.form.state.val($('form.registration #state').val());
      var optionId = $('form.registration #state').val();
      if (optionId && optionId!="") {
        $('form.registration #registration-form-postalCode').attr("pattern", ($('form.registration #state option#' + optionId).attr("regex-for-province")));
      } else {
        var regexStandard = CoinCard.el.form.postalCode.attr('data-regex');
        $('form.registration #registration-form-postalCode').attr("pattern", regexStandard);
      }
    })
  },

  /**
   * Method: Update Input Fields to Input Form
   */
  UpdateFormData: (data) => {

    if (data && !data.hasOwnProperty('error')) {

      /**
       * Setting input values with serviceResponse data
       */
      
      // > firstname
      CoinCard.el.form.firstname.val(data.first_name).trigger('change');

      // > lastname
      CoinCard.el.form.lastname.val(data.last_name).trigger('change');

      // > email
      CoinCard.el.form.email.val(data.email).trigger('change');

      // > birthday
      var dA = (data.birth_date.split('T')[0]).split('-');
      var correct_date = `${dA[2]}/${dA[1]}/${dA[0]}`;
      CoinCard.el.form.birthday.val(correct_date).trigger('change');

      // > postalCode
      CoinCard.el.form.postalCode.val(data.zip).trigger('change');

      // > prefixcode
      CoinCard.el.form.prefixcode.val().trigger('change');

      // > phone
      CoinCard.el.form.phone.val(data.mobile_number).trigger('change');

      // > gender
      var genderKeys = { M: 1, F: 2 };
      CoinCard.el.form.gender.val(genderKeys[data.gender]).trigger('change');

      // > address
      CoinCard.el.form.address.val(`${data.address} ${data.civic_number}`).trigger('change');

      // > city
      CoinCard.el.form.city.val(data.city).trigger('change');

      // > state
      CoinCard.el.form.state.val(data.state).trigger('change');

      // > country
      CoinCard.el.form.country.val(data.country).trigger('change');

    }

  },

  SendCardEmail: function () {
    $(document).on('click', '#sendcoincard', function (e) {
      window.$.spinner().start();
      $.ajax({
        url: $('#sendcoincard').attr('data-href'),
        type: 'get',
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          showMess.displayMessage(data.success, data.msg);
          window.$.spinner().stop();
        },
        error: function (err) {
          console.log('failed', err)
          showMess.displayMessage(false, err.msg);
          window.$.spinner().stop();
        },
      });
    })
  },

  resetPasswordForInactiveUser: function () {
    $("body").on("click", "#disabled-account-reset-psw", function (e) {
      var form = $('form.registration');
      e.preventDefault();
      let url = form.attr('data-forgotPassword');
      window.$.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          window.$.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
          } else {
            $('div.alert.alert-danger').remove();
            form.prepend('<div class="alert alert-success" role="alert">' + data.receivedMsgHeading + '. ' + data.receivedMsgBody + '</div>');
            setTimeout(function () {
              $('.edit-profile-alert').remove();
            }, 5000);
            if(data.returnUrl){
                    window.location.href = data.returnUrl;
            }
          }
        },
        error: function () {
          window.$.spinner().stop();
        },
      });
    });
  },

  ShowCoincardSection: function () {
    CoinCard.el.form.email.on('blur', function (e) {
      e.preventDefault();
      var mail = CoinCard.el.form.email.val();
      var url = CoinCard.el.form.email.attr('data-check-datahub-url');
      var isInError = $('div.col--email.col-md-6 div.error');
      if (mail && mail.length > 0 && isInError.length == 0) {
        //call to dataHub
        var errorAlert = $('div.alert.alert-danger.alert-dismissible');
        if (errorAlert && errorAlert.length > 0) {
          errorAlert.remove();
        }
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          data: {mail : mail},
          success: function (data) {
            if(!data.sfccCustomerAlreadyExist) {
              $('form.registration button').removeAttr('disabled');
              $('div.alert.alert-danger.alert-dismissible').remove();
              /*if (!data.isAssociable){
                $('div #haveCoinCard').removeClass('d-none');
              } else {
                $('div #haveCoinCard').addClass('d-none');
              }*/
            } else if (data.errorMsg){
              var errorHtml = '<div class="alert alert-danger alert-dismissible ' +
                'fade show" role="alert">' +
                 data.errorMsg + '</div>';

              $('form.registration button').attr('disabled', true);
              $('form.registration').prepend(errorHtml);
            }
          },
          error: function () {
            $('div #haveCoinCard').removeClass('d-none');
            $('form.registration button').removeAttr('disabled');
          },
        });
      }
    })
  }

  // /**
  //  * Check email; only Registration Flow.
  //  */
  // checkEmail: () => {
  //   if (CoinCard.config.IS_REGISTRATION_ACCOUNT) {
  //     const debounce_Email_Input = debounce(checkEmailForAssociation, 1000);

  //     $(CoinCard.el.form.email).on('keyup', debounce_Email_Input);

  //     function checkEmailForAssociation () {
  //       const email = $(CoinCard.el.form.email).val();

  //       if (email) {
  //         CoinCard.api.checkEmailForAssociation({ email })
  //         .done((data) => {
  //           if (data.statusCode === 'CUSTOMER_NOT_EXIST') {
  //             // enable button submit
  //             CoinCard.el.form.submit.attr('disabled', false);
  //             // reset errorMessage
  //             CoinCard.el.emailMessage.html('').hide();
  //           } else {
  //             // disable button submit
  //             CoinCard.el.form.submit.attr('disabled', true);
  //             // set errorMessage
  //             CoinCard.el.emailMessage.html(data.errorMessage).show();
  //           }
  //         })
  //         .fail((err) => {
  //           console.log(err)
  //         })
  //       } else {
  //         // reset errorMessage
  //         CoinCard.el.emailMessage.html('').hide();
  //       }
  //     }
  //   }
  // }
}

module.exports = CoinCard;